import React from "react";
import { PersonalSummaryProps } from "./types";
import { useUrlState } from "../../hooks";
import { Module } from "../../../../../constants";
import { AnalyticsPersonalSummary } from "./AnalyticsPersonalSummary";
import { ReflectionPersonalSummary } from "./ReflectionPersonalSummary";
import { BottomBar } from "../../components/bottom-bar";

import "./styles.scss";

export function PersonalSummary(props: PersonalSummaryProps) {
  const { module } = useUrlState();

  return (
    <div className="tg_page tg_page-layout tg_personal-summary">
      <div className="tg_personal-summary-inner">
        {module === Module.Analytics && <AnalyticsPersonalSummary {...props} />}
        {module === Module.Reflection && <ReflectionPersonalSummary />}
        {module === Module.Solution && <div>Solution Personal Summary</div>}
      </div>
      <BottomBar />
    </div>
  );
}
